import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "key-word"
};
const _hoisted_2 = {
  class: "tab-block flex rounded-md overflow-hidden"
};
const _hoisted_3 = {
  class: "ul-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "flex-1 bg-white pl-4 pt-2"
};
const _hoisted_6 = {
  class: "flex justify-between items-center pr-4 mb-2"
};
const _hoisted_7 = {
  class: "text-[#4E5969] text-sm font-medium"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_9 = {
  class: "flex flex-wrap relative"
};
const _hoisted_10 = ["title", "onClick"];
const _hoisted_11 = {
  key: 0,
  class: "flex items-center relative input-item"
};
const _hoisted_12 = {
  class: "h-4 mt-1 text-right text-xs choose"
};
const _hoisted_13 = {
  class: "text-[#165dff]"
};
import { ref, nextTick } from 'vue';
import { promiseTimeout } from '@vueuse/core';
import { ElMessage } from 'element-plus';
import { Plus, CloseBold, EditPen } from '@element-plus/icons-vue';
import cusInput from '@components/cusInput.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'KeyWord',
  props: {
    keywordList: {},
    disabled: {
      type: Boolean
    },
    keyWordArr: {}
  },
  emits: ["change"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const addRef = ref();
    const tabIns = ref(0);
    const showAdd = ref(false);
    const addVal = ref('');
    const keyWords = ref(props.keywordList);
    const editorIns = ref();
    const editorItem = ref();
    const inputRefArr = ref([]);
    const chooseArr = ref(props.keyWordArr || []);
    const handleUpdate = (val, index) => {
      keyWords.value[tabIns.value].list[index] = val;
      if (editorItem.value) {
        chooseArr.value.splice(chooseArr.value.indexOf(editorItem.value), 1, val);
      }
      emits('change', keyWords.value);
    };
    const handAdd = async () => {
      addVal.value = '';
      showAdd.value = true;
      await nextTick();
      addRef.value?.focus();
    };
    const changeTab = index => {
      tabIns.value = index;
      showAdd.value = false;
      editorIns.value = undefined;
    };
    const handleEdit = async (index, item) => {
      editorIns.value = index;
      await nextTick();
      inputRefArr.value[index].focus();
      if (chooseArr.value.includes(item)) {
        editorItem.value = item;
      } else {
        editorItem.value = '';
      }
    };
    const handleAdd = async () => {
      await nextTick();
      if (addVal.value) {
        if (keyWords.value[tabIns.value].list.includes(addVal.value)) {
          ElMessage.warning('关键词已存在');
          addVal.value = '';
          showAdd.value = false;
          return;
        }
        keyWords.value[tabIns.value].list.push(addVal.value);
        addVal.value = '';
        emits('change', keyWords.value);
      }
      showAdd.value = false;
    };
    const handleDel = index => {
      const [keyword] = keyWords.value[tabIns.value].list.splice(index, 1);
      if (chooseArr.value.includes(keyword)) {
        chooseArr.value.splice(chooseArr.value.indexOf(keyword), 1);
      }
      emits('change', keyWords.value);
    };
    const handDel = () => {
      keyWords.value[tabIns.value].list = [];
    };
    const handleBlur = async () => {
      await promiseTimeout(300);
      editorIns.value = undefined;
    };
    const handleChoose = item => {
      if (chooseArr.value.includes(item)) {
        chooseArr.value.splice(chooseArr.value.indexOf(item), 1);
      } else {
        if (chooseArr.value.length >= 20) {
          ElMessage.warning('最多选择20个关键词');
          return;
        }
        chooseArr.value.push(item);
      }
      emits('change', keyWords.value);
    };
    __expose({
      chooseArr
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyWords.value, (item, ins) => {
        return _openBlock(), _createElementBlock("li", {
          key: ins,
          class: _normalizeClass({
            active: tabIns.value === ins
          }),
          onClick: $event => changeTab(ins)
        }, _toDisplayString(item.label), 11, _hoisted_4);
      }), 128))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(keyWords.value[tabIns.value].label), 1), !__props.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
        type: "text",
        icon: _unref(Plus),
        class: "text-sm",
        onClick: handAdd
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 增加关键词 ", -1)]))]),
        _: 1
      }, 8, ["icon"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyWords.value[tabIns.value].list, (item, ins) => {
        return _openBlock(), _createElementBlock("div", {
          key: ins,
          class: _normalizeClass(["flex items-center relative input-item", {
            'pointer-events-none': __props.disabled,
            'is-edit': ins === editorIns.value
          }])
        }, [ins !== editorIns.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["name truncate", {
            active: chooseArr.value.includes(item)
          }]),
          title: chooseArr.value.includes(item) ? '点击取消选择' : '点击选择',
          onClick: $event => handleChoose(item)
        }, _toDisplayString(item), 11, _hoisted_10)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(cusInput, {
          ref_for: true,
          ref: el => inputRefArr.value[ins] = el,
          modelValue: item,
          placeholder: "[请输入关键词]",
          maxLength: "120",
          "onUpdate:modelValue": $event => handleUpdate($event, ins),
          onBlur: $event => handleBlur(ins)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]), !__props.disabled ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "close-icon cursor-pointer",
          color: "#165dff",
          onClick: $event => handleDel(ins)
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)], 64)), !__props.disabled ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          class: "edit-icon cursor-pointer",
          color: "#165dff",
          onClick: $event => handleEdit(ins, item)
        }, {
          default: _withCtx(() => [_createVNode(_unref(EditPen))]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)], 2);
      }), 128)), showAdd.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(cusInput, {
        modelValue: addVal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addVal.value = $event),
        ref_key: "addRef",
        ref: addRef,
        placeholder: "[请输入关键词]",
        maxLength: "120",
        onBlur: handleAdd,
        onKeydown: _withKeys(handleAdd, ["enter"])
      }, null, 8, ["modelValue"]), _createVNode(_component_el_icon, {
        class: "close-icon cursor-pointer",
        color: "#165dff",
        onClick: _cache[1] || (_cache[1] = $event => addVal.value = '')
      }, {
        default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
        _: 1
      })])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_12, [_cache[3] || (_cache[3] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(chooseArr.value.length), 1), _cache[4] || (_cache[4] = _createTextVNode(" 个关键词 ", -1))])]);
    };
  }
});